import Layout from '@/views/article'

const developWord = {
  path: '/article',
  component: Layout,
  redirect: '/article/help',
  meta: {
    title: '开放平台'
  },
  hidden: true,
  children: [
    {
      path: 'help',
      component: () => import('@/views/article/help/index'),
      name: 'help',
      meta: {
        title: '帮助文档'
      }
    },
    {
      path: 'development',
      component: () => import('@/views/article/development/index'),
      name: 'development',
      meta: {
        title: '开发文档'
      }
    }
  ]
}

export default developWord
